<template>
  <main class="main">
    <div>
      <div class="head mb-2">
        <div class="search ">
          <input autocomplete="off" name="search" v-model="search"  :placeholder="user_type == 1 ? 'Поиск по компании закупщика' : 'Поиск по компании поставщика'" @keyup="getStores()">
          <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
        </div>
        <app-select v-model="region" label="legal_address_city" :options="regions" class="select mb-0" placeholder="Регион"/>
        <app-select class="select mb-0" v-model="specialization" label="name" :options="specializations" placeholder="Специализация"/>
        <app-select class="select mb-0" v-model="type" label="name" :options="types" placeholder="Тип"/>
      </div>
      <div class="checkbox">
        <app-checkbox v-model="with_contract_only" class="mr-3">Есть договор с {{user_type == 1 ? 'закупщиком' : 'поставщиком'}}</app-checkbox>
        <app-checkbox v-model="mapHidden">Скрыть карту</app-checkbox>
      </div>
      <loading-container :loading="loading" >
      <app-map :items="shops" :hidden="mapHidden"/>
      <div class="table">
        <table >
          <tr>
            <th>Регион</th>
            <th>Специализация</th>
            <th>Тип</th>
            <th>Площадь</th>
            <th>Компания {{user_type == 1 ? 'закупщик' : 'поставщик'}}</th>
            <th width="100px">Рейтинг</th>
            <th width="120px">Есть договор?</th>
            <th width="60px">Меню</th>
          </tr>
          <tr v-for="(item, idx) in shops" :key="idx">
            <td>{{item.legal_address_city}}</td>
            <td>{{item.store_specialization ? item.store_specialization.name : ''}}</td>
            <td>{{item.store_type ? item.store_type.name : ''}}</td>
            <td>{{item.area}}</td>
            <td><router-link :to="'/profile/' + item.company.id">{{item.company.name}}</router-link></td>
            <td><app-rate-star :config="getStarsConfig(item)" /></td>
            <td :class="{yes: getContract(item) == 'Да'}">{{getContract(item)}}</td>
            <td><div class="menu"><img src="../assets/icons/eclipse-menu.svg" alt=""></div></td>
          </tr>
        </table>
      </div>
      </loading-container>
    </div>
  </main>
</template>
<script>
import AppMap from "../components/app-map";
import AppSelect from "../components/app-select";
import AppCheckbox from "../components/app-checkbox";
import AppRateStar from "@/components/app-rate-star";
import LoadingContainer from "@/components/loading-container";


export default {
  name: "shops",
  components: { AppMap, AppSelect, AppCheckbox, AppRateStar, LoadingContainer},
  data: ()=>({
    shops:[],
    mapHidden: false,
    search: '',
    regions: [],
    region: '',
    specializations: [],
    specialization: '',
    types: [],
    type: '',
    loading: true,
    with_contract_only: false,
    user_type: ''
  }),
  mounted() {
    this.getStores();
    this.getRegions();
    this.getSpecializations();
    this.getTypes();
    this.user_type = localStorage.getItem('type');
  },
  methods: {
    getStarsConfig(item){
      return {
        rating: item.review_avg ? item.review_avg : 0,
        amount: item.reviews_count ? item.reviews_count : 0,
        isIndicatorActive: true,
        isIndicatorAmountActive: true,
      }
    },
    getStores() {
      this.loading = true;
      this.$http.post('/get-all-stores', {
        token: localStorage.getItem('token'),
        search: this.search,
        region: this.region ? this.region.legal_address_city : '',
        specialization: this.specialization ? this.specialization.id : '',
        type: this.type ? this.type.id : '',
        with_contract_only: this.with_contract_only ? 1 : 0
      }).then(({data}) => {
        if (data.stores) {
          this.shops = data.stores;
        }
      })
      .catch((error) => {
          console.log(error)
      })
      .finally(() => this.loading = false)
    },
    getRegions() {
      this.$http.post('/get-store-regions', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.regions) {
          this.regions = data.regions;
          this.regions.unshift({
            id: 'Все',
            legal_address_city: 'Все'
          });
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    getSpecializations() {
      this.$http.post('/get-store-specializations', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.specializations) {
          this.specializations = data.specializations;
          this.specializations.unshift({
            id: 'Все',
            name: 'Все'
          });
        }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    getTypes() {
      this.$http.post('/get-store-types', {
        token: localStorage.getItem('token')
      }).then(({data}) => {
        if (data.types) {
          this.types = data.types;
          this.types.unshift({
            id: 'Все',
            name: 'Все'
          });
          }
      })
      .catch((error) => {
          console.log(error)
      })
    },
    getContract(item) {
      if (localStorage.getItem('type') == 1) {
        if (item.contract_purchaser !== null) {
          return 'Да';
        } else {
          return 'Нет';
        }
      } else {
        if (item.contract_provider !== null) {
          return 'Да';
        } else {
          return 'Нет';
        }
      }
    }
  },
  watch: {
    region: function () {
      this.getStores();
    },
    specialization: function () {
      this.getStores();
    },
    type: function () {
      this.getStores();
    },
    with_contract_only: function() {
      this.getStores();
    }
  }
}
</script>
<style>
.v-select {
  margin: 0;
}
</style>
<style scoped lang="scss">
.head{
  display: flex;
  align-items: center;
  width: 100%;
  .search {
    position: relative;
    width: 30%;
    display: flex;
    justify-content: flex-end;

    > input {
      border: 1px solid #EEF0F3;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 40px;
      padding: 0 40px 0 15px;
      outline: none;

      &:focus{
        border: 1px solid #2CB181;
      }
    }

    > img {
      position: absolute;
      right: 15px;
      bottom: 50%;
      transform: translateY(50%);
      width: 14px;
      height: 14px;
      cursor: pointer;
    }
  }
  .select{
    margin-left: 5px;
    width: 24%;
  }
}
.checkbox{
  display: flex;
  align-items: center;
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
      }
      &:hover{
        .menu{
          visibility: visible;
        }
      }
    }
    .yes{
      color: #2cb181;
    }
    .menu{
      display: flex;
      align-items: center;
      justify-content: center;
      visibility: hidden;
      cursor: pointer;
    }
  }
}

@media(max-width: 1277px) {
  .search {
    font-size:12px
  }
}
</style>
